import { Typography } from "@mui/material";
import FormDialog from "../../../../components/Dialog/FormDialog";
import React from "react";

const WorklogDialog = ({ showDelete, handleClose, loading, callback }) => (
  <FormDialog
    open={showDelete}
    handleClose={handleClose}
    loading={loading}
    handleSubmit={callback}
    buttonTxt="Delete"
    title="Confirmation: Delete confirmation"
    alignActions="center"
    cancelBtn={true}
    fullWidth={true}>
    <Typography className="align_text_center mb-2">
      Are you sure to you want to delete this item? This action can not be
      undone
    </Typography>
  </FormDialog>
);

export default React.memo(WorklogDialog);
